// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react_common/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react_common/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#form-inputs .form-btn.btn-primary,
#form-inputs .form-btn.btn-danger {
	background-color: var(--form-btn-bg) !important;
	border-color: var(--form-btn-bg) !important;
	color: var(--form-btn-color) !important;
}
#form-inputs .form-btn.btn-primary:hover,
#form-inputs .form-btn.btn-danger:hover {
	background-color: var(--form-btn-bg-hover) !important;
	border-color: var(--form-btn-bg-hover) !important;
	color: var(--form-btn-hover-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/form-cta.css"],"names":[],"mappings":"AAAA;;CAEC,+CAA+C;CAC/C,2CAA2C;CAC3C,uCAAuC;AACxC;AACA;;CAEC,qDAAqD;CACrD,iDAAiD;CACjD,6CAA6C;AAC9C","sourcesContent":["#form-inputs .form-btn.btn-primary,\n#form-inputs .form-btn.btn-danger {\n\tbackground-color: var(--form-btn-bg) !important;\n\tborder-color: var(--form-btn-bg) !important;\n\tcolor: var(--form-btn-color) !important;\n}\n#form-inputs .form-btn.btn-primary:hover,\n#form-inputs .form-btn.btn-danger:hover {\n\tbackground-color: var(--form-btn-bg-hover) !important;\n\tborder-color: var(--form-btn-bg-hover) !important;\n\tcolor: var(--form-btn-hover-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
